import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation, EffectFade } from 'swiper';
import Card from '../Card';
import styled from 'styled-components';
import Image from 'next/image';
import {
  LeftSwipperArrows,
  RightSwipperArrows
} from '../../shared-components/SwipperArrows/SwipperArrows';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

SwiperCore.use([Autoplay, Navigation, EffectFade]);

interface ATTRACTIONS {
  name: string;
  attractions: any;
}

const SwiperStyle = styled(Swiper)`
  .swiper-wrapper {
    padding-bottom: 3rem;
  }
`;

const Attractions = ({ name, attractions }: ATTRACTIONS) => {
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const swiperRef = useRef<any>(null);
  const updateSlideState = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiperInstance = swiperRef.current.swiper;
      setIsFirstSlide(swiperInstance.isBeginning);
      setIsLastSlide(swiperInstance.isEnd);
    }
  };
  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(0);
      setIsFirstSlide(true);
      setIsLastSlide(false);
    }
  }, [name]);

  useEffect(() => {
    const handleResize = () => {
      setTimeout(updateSlideState, 200);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
      <div className="text-start text-4xl font-bold py-10 pb-14">
        <h2
          className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold mb-6"
          id="what-you-will-see"
        >
          Best things to do in {name}
        </h2>
        <SwiperStyle
          ref={swiperRef}
          className="swiper_123 relative w-full pb-10"
          spaceBetween={20}
          slidesPerView={1}
          effect="slide"
          navigation={{ prevEl: '.prevSlide', nextEl: '.nextSlide' }}
          grabCursor
          a11y={{ enabled: true }}
          observer
          observeParents
          observeSlideChildren
          onSlideChange={updateSlideState}
          onReachEnd={() => setIsLastSlide(true)}
          onReachBeginning={() => setIsFirstSlide(true)}
          breakpoints={{
            400: {
              slidesPerView: 1.3
            },
            768: {
              slidesPerView: 2
            },
            800: {
              slidesPerView: 2.8
            },
            1024: {
              slidesPerView: 3
            },
            1200: {
              slidesPerView: 4
            }
          }}
        >
          {attractions.map((attraction: any, index: number) => {
            if (attraction.heroMedia[0]?.url) {
              return (
                <SwiperSlide key={attraction.name} className="w-full">
                  <Card
                    index={index}
                    slug={attraction.slug}
                    image={attraction.heroMedia[0].url}
                    cardSnippet={attraction.snippet}
                    city={attraction.name}
                  />
                </SwiperSlide>
              );
            }
          })}
        </SwiperStyle>

        <div id="slider-btn" className="flex justify-center mt-5">
          <div className="flex gap-2 justify-center items-center">
            <div className="prevSlide cursor-pointer">
              <LeftSwipperArrows isFirstSlide={isFirstSlide} />
            </div>
            <div className="nextSlide cursor-pointer">
              <RightSwipperArrows isLastSlide={isLastSlide} />
            </div>
          </div>
        </div>
      </div>
      <div className="mx-[8%] border-b-[1px] border-gray-300 "></div>
    </>
  );
};

export default Attractions;
